import { InputProps } from '@chakra-ui/react';
import React from 'react';

import {
  CmFormControl,
  CmFormLabel,
  CmInput,
  CmLeftIconAndInput,
} from '@/components/uiParts';

interface Props extends InputProps {
  fontWeight?: 'normal' | 'bold';
  isRequired?: boolean;
  label: string;
  id?: string;
  icon?: '' | 'search';
  isPassword?: boolean;
  disabled?: boolean;
}

export const CmLabelAndInput: React.FC<Props> = ({
  fontWeight = 'normal',
  isRequired = false,
  isPassword = false,
  isInvalid = false,
  label,
  id = '',
  icon,
  borderColor = 'inherit',
  width = 'full',
  children,
  ...rest
}) => {
  const props = {
    isRequired,
    isPassword,
    id,
    borderColor,
    ...rest,
  };
  return (
    <CmFormControl {...{ width, isInvalid }}>
      <CmFormLabel htmlFor={id} {...{ isRequired, fontWeight }}>
        {label}
      </CmFormLabel>
      {icon ? (
        <CmLeftIconAndInput {...{ ...props, icon }} />
      ) : (
        <CmInput {...{ ...props }} />
      )}
      {children}
    </CmFormControl>
  );
};
